import { AppBar, TitlePortal, type AppBarProps } from 'react-admin';
import { Box } from '@mui/material';
import CustomUserMenu from './CustomUserMenu';
import { IdleOrdersCounter } from './IdleOrdersCounter';
import { NotificationBell } from './notifications/NotificationBell';
import { VersionBadge } from './featureFlags/VersionSwitch';

/**
 * Pasek górny.
 *
 * Port z FreightFusion (`admin/CustomAppBar.jsx`). Ze źródła NIE przeniesiono
 * czterech elementów — każdy jest przywiązany do czegoś, czego ta instancja
 * nie dostaje:
 *
 * - `TokenStatusAlert` — odpytuje co 10 minut o stan tokenów giełd. Wejdzie
 *   razem z modułami TIMOCOM i Trans.eu, nie z powłoką.
 * - `OfferSourceAlert` — odpytuje co 30 minut `superadmin/offer-source-status`,
 *   czyli część wieloklieniecką, której nie budujemy (T.01).
 * - `TakeoverNotification` — podszywanie się pod użytkownika, poza zakresem.
 * - Przełącznik języka PL/EN/DE — wymaga `i18nProvider`, którego to repo
 *   jeszcze nie ma. Doda go osobne zadanie, wtedy przełącznik wraca.
 *
 * Dołożony (869f1fzha): licznik bezczynnych zleceń — wzorzec
 * „licznika eskalacji w nagłówku" ze źródła, ale liczony po słowniku stanów.
 * Dołożony (I.04, 24.09.2026): dzwonek powiadomień działów FTL i Trade.
 * Dołożony (12.10.2026, decyzja użytkownika): znacznik wybranej wersji
 * („obecna” / „nowa”) — tylko na środowisku akceptacyjnym.
 */
export const CustomAppBar = (props: AppBarProps) => (
  <AppBar {...props} userMenu={<CustomUserMenu />}>
    <TitlePortal />
    <Box sx={{ flex: 1 }} />
    <VersionBadge />
    <IdleOrdersCounter />
    <NotificationBell />
  </AppBar>
);

export default CustomAppBar;
